import PageHeading from "Layout/AppMain/PageHeading";
import React, { Fragment, useEffect, useState, useCallback } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { CardFooter, Col, Row } from "reactstrap";
import Records from "./table";
import { toast } from "react-toastify";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from "reactstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ReactComponent as LocationIcon } from "../../../../assets/utils/images/svgs/maps-icon.svg";
import { useCalculateDistance, useDistanceList, useSaveAddress, useUpdateDistance, useValidateAddress } from "Api/Coordinator/TravelCost";


const Default = () => {

    const [selectedCommunity, setSelectedCommunity] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const [editModal, setEditModal] = useState()
    const [addressData, setAddressData] = useState({});
    const [schoolIds, setSchoolIds] = useState([]);
    const [modalMessage, setModalMessage] = useState("");
    const [modalMessageType, setModalMessageType] = useState("");
    const [isValidating, setIsValidating] = useState(false);
    const [isValidated, setIsValidated] = useState(false);
    const [validationMessage, setValidationMessage] = useState('');
    const [validationError, setValidationError] = useState('');
    const [formattedAddress, setFormattedAddress] = useState('');
    const [addressConfirmed, setAddressConfirmed] = useState(false);
    const [apiError, setApiError] = useState('');
    const [showCalculateButton, setShowCalculateButton] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isCalculating, setIsCalculating] = useState(false);
    const [validatedAddressData, setValidatedAddressData] = useState(null);
    const [validationMessageType, setValidationMessageType] = useState("");
    const [sorting, setSorting] = useState({ key: "fullname", order: "" });
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSizeCount, setPageSizeCount] = useState(20);
    const [search, setSearch] = useState("");

    const validateAddressMutation = useValidateAddress();
    const saveAddressMutation = useSaveAddress();
    const calculateDistanceMutation = useCalculateDistance();
    const updateDistanceMutation = useUpdateDistance();


    const validationSchema = Yup.object().shape({
        tAddress: Yup.string()
            .max(500, 'Adres mag maximaal 500 tekens bevatten')
            .trim()
            .required('Adres is verplicht'),
        vPostCode: Yup.string()
            .max(10, 'Postcode mag maximaal 10 tekens bevatten')
            .trim()
            .required('Postcode is verplicht'),
        vCity: Yup.string()
            .max(30, 'Plaats mag maximaal 30 tekens bevatten')
            .trim()
            .required('Plaats is verplicht'),
        vCountry: Yup.string()
            .trim()
            .required('Land is verplicht')
    });

    const cities = [
        {
            key: "",
            value: "--- Kies land ---",
        },
        {
            key: "NL",
            value: "Nederland",
        },
        {
            key: "BE",
            value: "België",
        },
        {
            key: "DE",
            value: "Duitsland",
        }
    ];


    const {
        data: distanceData,
        isLoading,
        error,
        mutate,
    } = useDistanceList(selectedCommunity, {
        page: pageNumber,
        pageSize: pageSizeCount,
        order: sorting.order,
        search,
    });

    const totalCount = distanceData?.data?.totalCount;

    useEffect(() => {
        if (!distanceData) return;

        setSchoolIds(
            distanceData.data?.schoolList?.map((s) => s.iSchoolId) || []
        );

        const verifiedAdmin = distanceData.data.adminData?.find(
            (admin) => admin.bIsAddressVerified === 1
        );

        const formattedAddr =
            verifiedAdmin?.formattedAddress || "";

        setFormattedAddress(formattedAddr);

        if (verifiedAdmin) {
            setValidationMessage("Adres geverifieerd");
            setValidationMessageType("success");
            setIsValidated(true);
            setAddressConfirmed(true);
            setShowCalculateButton(true);
        } else {
            setValidationMessage("Adres niet gevalideerd");
            setValidationMessageType("danger");
            setAddressConfirmed(false);
            setShowCalculateButton(false);
        }
    }, [distanceData]);


    const userTablePageSize = (val) => {
        setPageNumber(1);
        setPageSizeCount(val);
    }
    const paginate = (val) => {
        setPageNumber(val);
    }

    const validateAddress = async (formValues, formik) => {
        const { tAddress, vPostCode, vCity, vCountry } = formValues;

        if (!tAddress || !vPostCode || !vCity || !vCountry) {
            setValidationError("Vul alle adresvelden in voordat je valideert.");
            return;
        }

        try {
            setIsValidating(true);
            setModalMessage("")
            setValidationError('');
            setValidationMessage('');
            setFormattedAddress('');
            setModalMessage("")
            setAddressConfirmed(false);
            const payload = {
                iAdminId: addressData?.iAdminId,
                tAddress,
                vPostCode,
                vCity,
                vCountry,
            };

            const res = await validateAddressMutation.trigger({
                data: payload,
            });

            if (res.status === true) {
                setIsValidated(true);

                setValidationMessage("Adres gevalideerd voor automatische afstand berekening");
                setValidationMessageType("");


                if (res.data?.formattedAddress) {
                    setFormattedAddress(res.data.formattedAddress);

                }

                formik.setValues({
                    tAddress: res.data.tAddress || formValues.tAddress,
                    vPostCode: res.data.vPostcode || formValues.vPostCode,
                    vCity: res.data.vCity || formValues.vCity,
                    vCountry: res.data.vCountry || formValues.vCountry,
                });

            } else {
                setValidationError("Google adres verificatie niet mogelijk , controleer het adres");
                setValidationMessageType("danger");

                setIsValidated(false);
            }
        } catch (error) {
            setValidationError("Validatie mislukt. Controleer het adres opnieuw.");
            setIsValidated(false);
        } finally {
            setIsValidating(false);
        }
    };


    const openAddressModal = (iAdminId, fullName) => {
        const selectedAdmin = distanceData?.data.adminData?.find(admin => admin.iAdminId === iAdminId);
        
        setValidationError('');
        setModalMessage('');
        setModalMessageType('');

        if (selectedAdmin) {
            const isVerified = selectedAdmin.bIsAddressVerified == 1;

            setAddressData({
                ...selectedAdmin,
                fullName:
                    fullName ||
                    `${selectedAdmin.vFirstName || ''} ${selectedAdmin.vMiddleName || ''} ${selectedAdmin.vLastName || ''}`.trim(),
            });
            setValidationMessage(isVerified ? "Adres geverifieerd" : "Adres niet gevalideerd");
            setValidationMessageType(isVerified ? "" : "error");


            setIsValidated(isVerified);
            setAddressConfirmed(isVerified);
            setShowCalculateButton(isVerified);

            setEditModal(true);
        }
    };

    const handleCalculations = async (formValues) => {
    
        try {

            setModalMessage("");
            setValidationMessage("")
            setIsCalculating(true);


            const payload = {
                iSchoolIds: schoolIds.join(','),
                iAdminId: addressData?.iAdminId,
                tAddress: formValues.tAddress,
                vCity: formValues.vCity,
                vCountry: formValues.vCountry,
                vPostCode: formValues.vPostCode,
                formattedAddress: formattedAddress,
            };
            const response = await calculateDistanceMutation.trigger({
                data: payload,
            });

            if (response.status === true) {
                toast.success("Afstanden succesvol berekend!");
                setEditModal(false);
                await mutate();

            } else {
                let errorMessage = "";

                if (response.setting === false) {
                    errorMessage =
                        "De instellingen van Google Maps zijn uitgeschakeld. Neem contact op met uw beheerder.";
                } else if (response.schoolIds === 0) {
                    errorMessage =
                        "Geen geldige schoolbestemmingen gevonden. Controleer de geselecteerde school";
                } else {
                    errorMessage =
                        "Google adres verificatie niet mogelijk, controleer het adres.";
                }

                setModalMessage(errorMessage);
                setModalMessageType("error");
            }

        } catch (error) {
            setModalMessage("Er is een fout opgetreden bij het berekenen van de afstand.");
            setModalMessageType("error");
        } finally {
            setIsCalculating(false);
        }
    };

    const confirmAddress = useCallback(async (formikValues, formik) => {
        try {
            const { tAddress, vPostCode, vCity, vCountry } = formikValues;

            if (!tAddress || !vPostCode || !vCity || !vCountry) {
                setValidationError("Vul alle adresvelden in voordat je bevestigt.");
                return;
            }

            setValidationError("");
            setApiError("");
            setIsSaving(true);
            const payload = {
                iAdminId: addressData.iAdminId,
                tAddress: formikValues.tAddress,
                vPostCode: formikValues.vPostCode,
                vCity: formikValues.vCity,
                vCountry: formikValues.vCountry,
                validationInfo: validatedAddressData || {},
            };

            const response = await saveAddressMutation.trigger({
                data: payload,
            });

            if (response.status === true) {
                const formatted = response.data || "";
                setValidationMessage("");
                setAddressConfirmed(true);
                setShowCalculateButton(true);
                formik.setFieldValue("addressDisabled", true);
                setFormattedAddress(formatted);
            } else {
                setApiError(response.message);
            }
        } catch (error) {
            console.log(error)
        }
        finally {
            setIsSaving(false)
        }
    }, [addressData.iAdminId]);

    const updateDistance = (() => {
        let timeout;

        return (distance, adminId, schoolId) => {
            clearTimeout(timeout);

            timeout = setTimeout(async () => {
                const dataToSend = {
                    dist: distance,
                    iAdminId: adminId,
                    iSchoolId: schoolId,
                };

                try {
                    const response = await updateDistanceMutation.trigger({
                        data: dataToSend,
                    });

                    if (response.status === true) {
                        toast.success("Afstand succesvol verwijderd");
                        await mutate();
                    }
                } catch (error) {
                    console.error(error);
                }
            }, 1000);
        };
    })();

    const handleCommunityChange = (event) => {
        setSelectedCommunity(event.target.value);
        setPageNumber(1)
    };

    return (
        <Fragment>
            <TransitionOnLoad>
                <div>
                    <Row>
                        <Col md="10" lg="10">
                            <PageHeading />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="12" className="pb-5">
                            {distanceData && (
                                <Records
                                    data={distanceData.data || []}

                                    userTablePageSize={userTablePageSize}
                                    pageNumber={pageNumber}
                                    setPageNumber={setPageNumber}

                                    pageSizeCount={pageSizeCount}
                                    setPageSizeCount={setPageSizeCount}


                                    search={search}
                                    setSearch={setSearch}

                                    paginate={paginate}
                                    sorting={sorting}
                                    setSorting={setSorting}
                                    showLoader={isLoading}
                                    updateDistance={updateDistance}
                                    openAddressModal={openAddressModal}
                                    totalCount={totalCount}
                                />)
                            }

                        </Col>
                    </Row>

                </div>
            </TransitionOnLoad>
            {!isLoading &&
                <div className="chat-layout-footer verzoken-footer-height">
                    <CardFooter className="chat-layout-footer__inner gebruikers-footer">
                        <div className="d-flex gap-3 col-1">
                            <select
                                className="form-select"

                                value={selectedCommunity}
                                onChange={handleCommunityChange}
                            >
                                <option value='' disabled>Alle Organisaties</option>
                                {distanceData?.data.communityList?.map((community, index) => {
                                    return (
                                        <option key={index} value={community.iCommunityId}>
                                            {community.name}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </CardFooter>
                </div>
            }

            <Modal
                isOpen={editModal}
                toggle={() => {
                    setEditModal(false);
                    setModalMessage("");

                }}
                className="feedback-modal-style link-form modal-centered"
            >
                <ModalHeader toggle={() => setEditModal(false)}>
                    Adres wijzigen
                </ModalHeader>

                <Formik
                    enableReinitialize
                    initialValues={{
                        tAddress: validatedAddressData?.tAddress || addressData?.tAddress || '',
                        vPostCode: validatedAddressData?.vPostCode || addressData?.vPostCode || '',
                        vCity: validatedAddressData?.vCity || addressData?.vCity || '',
                        vCountry: validatedAddressData?.vCountry || addressData?.vCountry || ''
                    }}

                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        handleCalculations(values);
                    }}


                >
                    {(formik) => {
                        const { values, handleChange } = formik;

                        const resetValidationState = () => {
                            if (isValidated || validationMessage || validationError) {
                                setIsValidated(false);
                                setValidationMessage('');
                                setValidationError('');
                                setModalMessage("")
                            }
                        };

                        return (
                            <Form>
                                <ModalBody>
                                    <FormGroup>
                                        <h4 className="mb-3"> {addressData?.fullName || ''}</h4>
                                        <Label>Adres:</Label>
                                        <Field
                                            type="text"
                                            name="tAddress"
                                            placeholder="Adres"
                                            className="form-control"
                                            onChange={(e) => {
                                                handleChange(e);
                                                resetValidationState();
                                            }}
                                        />
                                        <ErrorMessage name="tAddress" component="div" className="text-danger small mt-1" />

                                        <Label className="mt-4">Postcode:</Label>
                                        <Field
                                            type="text"
                                            name="vPostCode"
                                            placeholder="Postcode"
                                            className="form-control"
                                            onChange={(e) => {
                                                handleChange(e);
                                                resetValidationState();
                                            }}
                                        />
                                        <ErrorMessage name="vPostCode" component="div" className="text-danger small mt-1" />

                                        <Label className="mt-4">Woonplaats:</Label>
                                        <Field
                                            type="text"
                                            name="vCity"
                                            placeholder="Woonplaats"
                                            className="form-control"
                                            onChange={(e) => {
                                                handleChange(e);
                                                resetValidationState();
                                            }}
                                        />
                                        <ErrorMessage name="vCity" component="div" className="text-danger small mt-1" />

                                        <Label className="mt-4">Land:</Label>
                                        <Field
                                            as='select'
                                            name="vCountry"
                                            placeholder="Land"
                                            className="form-select"
                                            onChange={(e) => {
                                                handleChange(e);
                                                resetValidationState();
                                            }}>

                                            {cities.map(option => {
                                                return (
                                                    <option key={option.key} value={option.key}>
                                                        {option.value}
                                                    </option>
                                                )
                                            })}
                                        </Field>
                                        <ErrorMessage name="vCountry" component="div" className="text-danger small mt-1" />
                                        {modalMessage && (
                                            <p
                                                className={`text-start small fw-normal mb-1 mt-4 ${modalMessageType === "error" ? "text-danger" : "text-info"
                                                    }`}
                                            >
                                                {modalMessage}
                                            </p>
                                        )}

                                        {formattedAddress && isValidated && !addressConfirmed && (
                                            <p className=" small mt-3">
                                                Google maps adres: {formattedAddress}
                                            </p>
                                        )}


                                        {validationMessage && (
                                            <p
                                                className={`small mt-3 ${validationMessageType === "error" ? "text-danger" : ""
                                                    }`}
                                            >
                                                {validationMessage}
                                            </p>
                                        )}




                                        {validationError && (
                                            <p className="text-danger small mt-3">{validationError}</p>
                                        )}



                                    </FormGroup>
                                </ModalBody>

                                <ModalFooter className="d-flex align-items-center justify-content-center py-3">
                                    <Button
                                        outline
                                        className="btn-outline-primary-blue btn-color-style py-2 px-3 d-flex gap-2 align-items-center"
                                        type="button"
                                        color="primary"
                                        onClick={() => setEditModal(false)}
                                    >
                                        Sluiten
                                    </Button>


                                    {
                                        !isValidated ? (
                                            <Button
                                                outline
                                                className="btn-outline-primary-blue btn-color-style py-2 px-3 d-flex gap-2 align-items-center"
                                                type="button"
                                                color="primary"
                                                disabled={isValidating}
                                                onClick={() => validateAddress(values, formik)}
                                            >
                                                <LocationIcon style={{ width: 18, height: 18 }} /> {isValidating ? 'Adres wordt gevalideerd...' : 'Valideer adres'}
                                            </Button>
                                        ) : addressConfirmed ? (
                                            <Button
                                                outline
                                                className="btn-outline-primary-blue btn-color-style py-2 px-3 d-flex gap-2 align-items-center"
                                                type="button"
                                                color="primary"
                                                onClick={() => handleCalculations(values)}
                                                disabled={isCalculating}
                                            >
                                                {isCalculating ? 'Afstanden worden berekend...' : 'Afstanden berekenen'}
                                            </Button>
                                        ) : (
                                            <Button
                                                outline
                                                className="btn-outline-primary-blue btn-color-style py-2 px-3 d-flex gap-2 align-items-center"
                                                type="button"
                                                color="primary"
                                                onClick={() => confirmAddress(values, formik)}
                                                disabled={isSaving}
                                            >
                                                {isSaving ? 'Adres wordt opgeslagen...' : 'Toepassen'}
                                            </Button>
                                        )
                                    }

                                </ModalFooter>
                            </Form>
                        )
                    }}
                </Formik>
            </Modal>

        </Fragment>
    )
};

export default Default;
